<div class="card step-card flex flex-column">

  <form [formGroup]="credentialsForm" *ngIf="credentialsForm">
    <div class="grid">
      <div class="col-12">
        <div class="form-field col-12">
          <label>{{'attribute.passwordtemporary' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-checkbox id="temporal" formControlName="temporal" binary="true" class="w-full"></p-checkbox>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.password' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-password
            [toggleMask]="true"
            styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full-password w-full-password"
            class="w-full"
            id="value"
            formControlName="value"
          ></p-password>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.repeatpassword' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-password
            [toggleMask]="true"
            styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full-password"
            class="w-full"
            id="confirmValue"
            formControlName="confirmValue"
          ></p-password>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>&nbsp;</label>
        </div>
        <div class="col-12">
          <button
            [label]="'common.generatepassword' | transloco"
            (click)="generatePass()"
            pButton
            class="p-button-secondary"
            icon="pi pi-key"
          ></button>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          [disabled]="!credentialsForm?.valid"
          (click)="onNextStep()"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/management/users'"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>

</div>
